import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';

import loader from '../../assets/images/loader.svg';

const ContainerStyled = styled.div`
  height: 100%;
  width: 100px;
`;

const IndicatorStyled = styled.img`
  width: 70px;
  height: 70px;
  transform: translate(-50%, -50%);
  margin: 0 !important;
`;

Spin.setDefaultIndicator(<IndicatorStyled src={loader} alt='loader' />);

const CircularProgress: React.FC<{
  className?: string;
  position?: 'start' | 'center' | 'end';
  width?: string;
  height?: string;
}> = ({ className, position = 'center', width = '100%', height = '70px' }) => (
  <ContainerStyled
    className={`loader gx-d-flex  ${className}`}
    style={{
      justifyContent: position,
    }}>
    <img height={height} style={{ maxHeight: '100%' }} width={width} src={loader} alt='loader' />
  </ContainerStyled>
);

export default CircularProgress;
